/**
 * Rounds a number to 7 decimal places and removes trailing zeros.
 * @param num - The number to round.
 * @returns The rounded number as a string.
 */
export const round = (num: number) =>
  num
    .toFixed(7)
    .replace(/(\.[0-9]+?)0+$/, '$1')
    .replace(/\.0$/, '')
/**
 * Converts pixels to rems by dividing the given value by 16 and rounding to 7 decimal places.
 * @param px - The number of pixels to convert.
 * @returns The converted value as a string with "rem" unit.
 */
export const rem = (pixels: number) => `${round(pixels / 16)}rem`
/**
 * Calculates the unitless value of a line height relative to the font size.
 * @param lineHeight - The line height value in pixels.
 * @param fontSize - The font size value in pixels.
 * @returns The unitless value.
 */
export const unitLess = (lineHeight: number, fontSize: number) => `${lineHeight / fontSize}`

export const getMousePos = (e: MouseEvent) => {
  return {
    x: e.clientX,
    y: e.clientY
  }
}
